import { render } from "./detail-master-blueprint.vue?vue&type=template&id=dc62dd2c&scoped=true"
import script from "./detail-master-blueprint.vue?vue&type=script&lang=js"
export * from "./detail-master-blueprint.vue?vue&type=script&lang=js"

import "./detail-master-blueprint.vue?vue&type=style&index=0&id=dc62dd2c&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc62dd2c"]])

export default __exports__